import React from 'react';
import i18next from 'i18next';

import type { IOrder } from 'types';

type OrderPaymentDetailsProps = {
  order: IOrder;
};

export const OrderPaymentDetails: React.FC<OrderPaymentDetailsProps> = ({
  order,
}) => {
  const payment = order.payment;
  if (!payment) {
    return (
      <>
        {i18next.t('order-payment-details.no-payment')}
        <br />
        {i18next.t('order-payment-details.payment-type', { type: order.payment_type })}
      </>
    );
  }
  return payment.driver !== 'offline' ? (
    <>
      <div>{i18next.t('order-payment-details.status', { status: payment.status })}</div>
      <div>
        {i18next.t('order-payment-details.id', { id: payment.id, externalId: payment.external_id })}
      </div>
    </>
  ) : (
    <div>{i18next.t('order-payment-details.offline-payment', { type: payment.type })}</div>
  );
};

export default OrderPaymentDetails;
